import React, {Component} from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import * as Colors from "../../utils/Color";

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder',
];


/**
 * `SelectField` can handle multiple selections. It is enabled with the `multiple` property.
 */
export default class SelectFieldExampleMultiSelect extends Component {
    state = {
        values: [],
    };

    handleChange = (event, index, values) => this.setState({values});

    menuItems(values) {
        return names.map((name) => (
            <MenuItem
                key={name}
                insetChildren={true}
                checked={values && values.indexOf(name) > -1}
                value={name}
                primaryText={name}
            />
        ));
    }

    render() {
        const {values} = this.state;
        return (
            <SelectField
                fullWidth
                multiple={true}
                hintText="Select a name"
                value={values}
                hintStyle={{ fontWeight: '700', color: Colors.grey50 }}
                underlineStyle={{ borderColor: Colors.grey }}
                onChange={this.handleChange}
                iconStyle={{ fill: Colors.grey50 }}
                selectedMenuItemStyle={{ color: "rgba(0, 0, 0, 0.87)", fontWeight: "700" }}
            >
                {this.menuItems(values)}
            </SelectField>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/UI/MultipleSelect.js